export default __webpack_public_path__ + "static/media/icn-home.6f69ba2e.svg";